import { FC } from "react";
import { withRoles, wrapClick } from "utils";
import { useQuery } from "@apollo/client";
import { CewpUserView } from "components/cards";
import { Modal } from "components/layouts";
import { useSearch, useNavigate } from "react-location";
import { LocationGenerics } from "router/location";
import { GET_CEWP_USER } from "./apollo";

interface ViewCewpUserContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
}

const ViewCewpUserContainer: FC<ViewCewpUserContainerProps> = ({
  open,
  setOpen,
}) => {
  const searchParams = useSearch<LocationGenerics>();
  const navigate = useNavigate<LocationGenerics>();
  const { data, loading } = useQuery(GET_CEWP_USER, {
    variables: {
      id: searchParams.id,
    },
    skip: !searchParams.id,
    notifyOnNetworkStatusChange: false,
  });

  const updateItem = () => {
    navigate({
      search: (old) => ({
        ...old,
        modal: "update",
      }),
    });
  };

  const canEdit = data?.user?.status === "Active";

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="CEWP User Information"
      description="Details of the CEWP user are shown below"
      renderActions={() => (
        <>
          {withRoles(["Super"])(
            canEdit ? (
              <button
                type="button"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
                onClick={wrapClick(updateItem)}
              >
                Edit
              </button>
            ) : null,
          )}
        </>
      )}
    >
      {data?.user?._id && <CewpUserView user={data.user} />}
    </Modal>
  );
};

export default ViewCewpUserContainer;
